import { useSEO } from "@/hooks/useSEO";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { COMPANY } from "@/lib/constants";

const openCookiePrefs = () => window.dispatchEvent(new Event("open-cookie-preferences"));

export default function Privacy() {
  useSEO({
    title: "Privacy & Cookie Policy | Esprit Home Healthcare",
    description: "How Esprit Home Healthcare collects, uses, and protects your information, and how we use cookies on our website.",
    canonical: "/privacy",
  });

  return (
    <div>
      <PageHeader overline="Legal" title="Privacy & Cookie Policy" subtitle="Your privacy matters to us. This page explains how we handle your information and use cookies." />

      <section className="container-page py-16 lg:py-20 max-w-3xl space-y-10">
        <Reveal>
          <h2 className="font-heading font-bold text-2xl text-primary">Information We Collect</h2>
          <p className="text-lg text-foreground/80 mt-3 leading-relaxed">
            When you submit a form on our website, we collect the information you provide — such as your name, email, phone number, ZIP code, and the details of your inquiry — so our team can contact you and arrange care. We do not sell your personal information.
          </p>
        </Reveal>
        <Reveal>
          <h2 className="font-heading font-bold text-2xl text-primary">How We Use Your Information</h2>
          <p className="text-lg text-foreground/80 mt-3 leading-relaxed">
            We use your information to respond to inquiries, coordinate home health services, verify insurance benefits, and improve our services. We handle health-related information with care and in accordance with applicable laws.
          </p>
        </Reveal>
        <Reveal>
          <h2 className="font-heading font-bold text-2xl text-primary">Cookies</h2>
          <p className="text-lg text-foreground/80 mt-3 leading-relaxed">
            We and selected third parties use cookies or similar technologies for technical purposes and, with your consent, for measurement and marketing (personalized ads). Technical cookies are necessary for the site to function. You can freely give, deny, or withdraw consent at any time.
          </p>
          <button onClick={openCookiePrefs} className="inline-flex items-center gap-2 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground h-12 px-6 font-semibold mt-4 transition-colors">
            Manage Cookie Preferences
          </button>
        </Reveal>
        <Reveal>
          <h2 className="font-heading font-bold text-2xl text-primary">Contact Us</h2>
          <p className="text-lg text-foreground/80 mt-3 leading-relaxed">
            For any privacy questions, contact us at {COMPANY.phone} or {COMPANY.email}. Mailing address: {COMPANY.address1}, {COMPANY.address2}.
          </p>
        </Reveal>
      </section>
    </div>
  );
}
